export default __webpack_public_path__ + "0907301260bde39252e781119c3a4319.svg";